export class VariableAssignment {
  spaceId!: string
  variableId!: string
  recipientId!: string
}

export default class CreateVariableAssignmentRequest {
  assignments!: VariableAssignment[]
  assignAllUnassigned?: boolean
  recipientId?: string
  documentVariableIds?: string[]
}
